import type { BenefitsSectionProps } from "~/sections/Content/BenefitsSection"
import Image from "~/components/ui/Image"
import clsx from "~/sdk/clx"

export const BenefitsMosaic = ({ items }: BenefitsSectionProps) => {
    return (
        <ul className='grid max-w-3xl grid-cols-2 gap-2 mx-auto'>
            {items.map((item, index) => {
                const lastItem = index === items.length - 1

                const Container = item.href ? 'a' : 'div'
                const containerProps = item.href
                    ? { href: item.href, target: item.target ? '_blank' : '_self' }
                    : {}

                return (
                    <li
                        key={`${index}-${item.href ?? item.label ?? ''}`}
                        className={clsx(
                            'p-2 bg-black',
                            lastItem && 'col-span-full',
                        )}
                    >
                        <Container
                            className='flex items-center justify-center'
                            {...containerProps}
                        >
                            {item.image && (
                                <div className='flex w-full h-full max-w-[20px] max-h-[20px] object-cover mr-3'>
                                    <Image
                                        width={20}
                                        height={20}
                                        src={item.image}
                                        alt={item.label}
                                    />
                                </div>
                            )}
                            <div
                                className='text-white text-center text-[10px] max-w-[300px] [&_strong]:text-bege [&_strong]:font-black'
                                dangerouslySetInnerHTML={{
                                    __html: item.description,
                                }}
                            />
                        </Container>
                    </li>
                )
            })}
        </ul>
    )
}
